<script setup>
import { computed } from 'vue'

const props = defineProps({
  variant: {
    type: String,
    required: true,
    validator: (value) => ['human', 'ai'].includes(value),
  },
})

const variantClass = computed(() => (props.variant === 'ai' ? 'bot' : 'user'))
</script>

<template>
  <div :class="['message', variantClass]">
    <slot />
  </div>
</template>

<style scoped>
.message {
  max-width: 70%;
  min-width: 0;
  padding: 10px;
  border-radius: 8px;
  margin: 5px 0;
  overflow-wrap: anywhere;
  line-height: 1.4;
}

.user {
  background: #4caf50;
  color: white;
  align-self: flex-end;
}

.bot {
  background: white;
  color: black;
  align-self: flex-start;
}

@media (max-width: 700px) {
  .message {
    max-width: 90%;
  }
}
</style>
